export enum WidgetInteractionEnum {
    Init = 'init',
    View = 'view',
    ChanceInteraction = 'interactionc',
    FirstInteraction = 'interactionf'
}
